{
  "rig_rlse_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Rig Release Date",
      "width": 110,
      "isShownByDefault": true
    }
  },
  "on_prod_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "On Prod Date",
      "width": 110,
      "isShownByDefault": true
    }
  },
  "last_spud_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Spud Date",
      "width": 110,
      "isShownByDefault": true
    }
  },
  "license_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Licence Date",
      "width": 110,
      "isShownByDefault": true
    }
  },
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licence Number",
      "isShownByDefault": true
    }
  },
  "licensee": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee",
      "isShownByDefault": true
    }
  },
  "formations": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formations",
      "isShownByDefault": true
    }
  },
  "field_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field",
      "isShownByDefault": true
    }
  },
  "surface_uwi": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Surface Location",
      "width": 140,
      "isShownByDefault": true
    }
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Province",
      "width": 60,
      "isShownByDefault": true
    }
  },
  "uwis": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "UWIs",
      "width": 200,
      "isShownByDefault": true
    }
  },
  "wellbores": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "isNotRenderable": true
    }
  }
}
